import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Slide as n, toast as r } from "react-toastify";
//#region src/components/notification/Notification.tsx
var i = 5e3, a = 999999, o = {
	position: "top-right",
	hideProgressBar: !0,
	pauseOnHover: !0,
	draggable: !0,
	theme: "colored",
	transition: n
}, s = (n) => {
	let { title: r, message: i } = n;
	return /* @__PURE__ */ e("div", {
		className: "notification",
		children: /* @__PURE__ */ t("div", {
			className: "notification-message",
			role: "alert",
			children: [r && /* @__PURE__ */ e("h4", {
				className: "title",
				children: r
			}), /* @__PURE__ */ e("div", {
				className: "message",
				children: i
			})]
		})
	});
}, c = (t) => {
	let { timeout: n, callback: r, iconClassName: i, closeButton: a = !1, hideProgressBar: s = !0, closeOnClick: c = !0 } = t;
	return {
		...o,
		autoClose: n || 5e3,
		onClick: r,
		hideProgressBar: s,
		closeOnClick: c,
		icon: /* @__PURE__ */ e("span", { className: `uikit-icon ${i}` }),
		closeButton: a ? ({ closeToast: t }) => /* @__PURE__ */ e("button", {
			className: "notification-close",
			type: "button",
			children: /* @__PURE__ */ e("span", { className: "uikit-icon icon-remove" })
		}) : !1
	};
}, l = (() => {
	let t = (t, n, i) => {
		let { title: a, timeout: o, callback: l, closeButton: u, closeOnClick: d, hideProgressBar: f } = i ?? {}, p = {
			default: "",
			success: "icon-ok text-size-18",
			info: "icon-info-sign text-size-20",
			warn: "icon-warning-sign text-size-20",
			error: "icon-error-sign text-size-20"
		};
		return t === "default" ? r(/* @__PURE__ */ e(s, {
			message: n,
			title: a
		}), c({
			timeout: o,
			callback: l,
			closeButton: u,
			closeOnClick: d,
			hideProgressBar: f,
			iconClassName: p[t]
		})) : r[t](/* @__PURE__ */ e(s, {
			message: n,
			title: a
		}), c({
			timeout: o,
			callback: l,
			closeButton: u,
			closeOnClick: d,
			hideProgressBar: f,
			iconClassName: p[t]
		}));
	};
	return {
		default: (e, n) => t("default", e, n),
		success: (e, n) => t("success", e, n),
		info: (e, n) => t("info", e, n),
		warning: (e, n) => t("warn", e, n),
		error: (e, n) => t("error", e, n)
	};
})();
//#endregion
export { i as DEFAULT_NOTIFICATION_TIMEOUT_IN_MS, a as NOTIFICATION_TIMEOUT_INFINITE, l as default };

//# sourceMappingURL=Notification.js.map